import React,{ useEffect } from 'react';
import { Container, Typography, Grid, Card, CardContent, Box, Chip, Button } from '@mui/material';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PhoneIcon from '@mui/icons-material/Phone';
import HistoryIcon from '@mui/icons-material/History';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Adds smooth scrolling animation
    });
  },[]);

  return (
    <Container maxWidth="lg" sx={{ py: 6 ,mb:10}}>
      {/* Header Section */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <LocalPharmacyIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
          متجرنا
        </Typography>
        <Typography variant="h5" color="text.secondary">
          نخدمكم منذ 15 عامًا بكل إخلاص واحترافية
        </Typography>
      </Box>

      {/* Main Content */}
      <Grid container spacing={6} style={{width:'calc(100% + 16px)',marginRight:-16}}>
        {/* History Section */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 2 }}>
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <HistoryIcon sx={{ fontSize: 50, color: 'primary.main', mb: 2 }} />
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                15 عامًا من الخبرة
              </Typography>
              <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                منذ تأسيسنا في عام 2009، كنا نعمل بتفانٍ لتقديم أفضل الخدمات المواد الغذائية بالجملة. نحن نفتخر بثقة عملائنا الكرام التي اكتسبناها على مدار 15 عامًا من الخدمة المتميزة.
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                نحرص دائمًا على توفير أجود الأمواع والمنتجات الصحية مع الحفاظ على أعلى معايير الجودة والسلامة.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Contact Information */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 2 }}>
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <PhoneIcon sx={{ fontSize: 50, color: 'primary.main', mb: 2 }} />
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                تواصل معنا
              </Typography>
              <Typography variant="h6" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
                أرقام الهاتف:
              </Typography>
              
              <Box sx={{ my: 2 }}>
                <Chip 
                  icon={<PhoneIcon />} 
                  label="01277177219" 
                  sx={{ fontSize: '1.2rem', p: 2, m: 1, direction: 'ltr' }} 
                  color="primary" 
                  variant="outlined"
                />
                <Chip 
                  icon={<PhoneIcon />} 
                  label="012121883007" 
                  sx={{ fontSize: '1.2rem', p: 2, m: 1, direction: 'ltr' }} 
                  color="primary" 
                  variant="outlined"
                />
              </Box>
              
              <Typography variant="h6" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
                أوقات العمل:
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2 }}>
                <AccessTimeIcon sx={{ mr: 1, color: 'primary.main' }} />
                <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                  كل أيام الأسبوع من 8 صباحًا حتى 2 صباحًا
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

          {/* Location Section */}
        <Grid item xs={12}>
          <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <LocationOnIcon sx={{ fontSize: 50, color: 'primary.main', mb: 2 }} />
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                عنواننا
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                نحن موجودون في:
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.2rem', mt: 2 }}>
                شارع ال عمران، الحي الثاني 6 اكتوبر , جمهورية مصر العربية
              </Typography>
              
              {/* Google Maps Embed */}
              <Box sx={{ mt: 4, height: '400px', borderRadius: 2, overflow: 'hidden' }}>
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1728.2188007629898!2d30.942356565556207!3d29.966851432735947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145856f582af74d3%3A0x187a408ca0246456!2z2LXZitiv2YTZitipINivINil2YrZhdin2YYg2K7Yp9i32LE!5e0!3m2!1sen!2seg!4v1758056068527!5m2!1sen!2seg"
                  width="100%" 
                  height="100%" 
                  style={{ border: 0, borderRadius: '8px' }} 
                  allowFullScreen 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Elite Pharmacy Location"
                ></iframe>
              </Box>
              
              <Button 
                variant="contained" 
                size="large" 
                sx={{ mt: 3 }}
                onClick={() => window.open('https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1728.2188007629898!2d30.942356565556207!3d29.966851432735947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145856f582af74d3%3A0x187a408ca0246456!2z2LXZitiv2YTZitipINivINil2YrZhdin2YYg2K7Yp9i32LE!5e0!3m2!1sen!2seg!4v1758056068527!5m2!1sen!2seg', '_blank')}
              >
                افتح الخريطة في تطبيق Google Maps
              </Button>
            </CardContent>
          </Card>
        </Grid>



        {/* Mission Section */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 2 }}>
            <CardContent sx={{ p: 4 }}>
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark', textAlign: 'center' }}>
                رسالتنا
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem', lineHeight: 1.8, textAlign: 'center' }}>
                نهدف إلى تقديم رعاية صحية شاملة وعالية الجودة من خلال توفير المواد الغذائية والمنتجات الصحية المعتمدة، مع تقديم الجودة والتغليف لضمان سلامة وصحة عملائنا.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Values Section */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 2 }}>
            <CardContent sx={{ p: 4 }}>
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark', textAlign: 'center' }}>
                قيمنا
              </Typography>
              <ul style={{ paddingRight: '20px', fontSize: '1.1rem', lineHeight: 2 }}>
                <li>الجودة والتميز في الخدمة</li>
                <li>النزاهة والشفافية</li>
                <li>الالتزام بالمعايير الصحية</li>
                <li>الابتكار والتطوير المستمر</li>
              </ul>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutPage;